import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-25cc77b4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "structure-info" }
const _hoisted_2 = { class: "info-item" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "icon iconfont icon-tishi" }),
  /*#__PURE__*/_createTextVNode(" 文件说明：购买后该文件包含三维图、BOM、二维图、介绍参数四部分文件，即购买之日起可享有30天内不限次数下载 ")
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon iconfont icon-tishi" }, null, -1))
const _hoisted_5 = { class: "item-img" }
const _hoisted_6 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("p", null, [
        _hoisted_4,
        _createTextVNode(" 用到的软件：" + _toDisplayString(_ctx.getSolidWorksVersion(_ctx.goodsModel)) + "、CAXA 2021、Auto Cad 2016、Excel 2010以上的版本格式、看图软件，如想了解更多请点击“使用指南”查看 ", 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.imgUrl, (item, index) => {
        return (_openBlock(), _createElementBlock("img", {
          src: _ctx.getimgUrl(item)
        }, null, 8, _hoisted_6))
      }), 256))
    ])
  ]))
}